import { useState, useEffect } from "react";
import Paper from "@mui/material/Paper";
import Stack from '@mui/material/Stack';
import Dialog from '@mui/material/Dialog';
import { NewButton } from "./index";

import DialogContent from '@mui/material/DialogContent';

export const NominateCards = () => {
   const [open, setOpen] = useState(false);

   useEffect(() => {
      const script = document.createElement('script');
      script.src = 'https://js.hsforms.net/forms/v2.js';
      document.body.appendChild(script);

      script.addEventListener('load', () => {
         if (window.hbspt) {
            window.hbspt.forms.create({
               portalId: '536350',
               formId: '5f67c12f-e4b9-4386-950a-ce96f986918f',
               target: '#preregForm'
            })
         }
      });
   }, [open]);

   const cards = [
      {
         name: "NOMINATE A COMPANY",
         bgColor: "#092ca8",
         img: "./assets/media/noto-v1_sports-medal(1).png",
         content: "Nominate your colleagues, portfolio companies, or partners for the opportunity to present!",
         btnTxt: "NOMINATE",
         btnLink: "https://youngstartup.com/upcoming",
      },
      {
         name: "VENTURE NURTURING",
         img: "./assets/media/grph(1).png",
         bgColor: "#1070ff",
         content: <div><div>Free access for seed stage startups 25 Tickets Available</div> <br /> *Conditions Apply</div>,
         btnTxt: "DETAILS",
         btnLink: "https://youngstartup.com/upcoming",
      },
      {
         name: "PRESS PASSES",
         img: "./assets/media/badge(1).png",
         bgColor: '#00c2ff',
         content:
            "If you qualify and would like a press pass, visit here for details.",
         btnTxt: "PRESS PASS",
         btnLink: "https://youngstartup.com/upcoming",
      },
   ];



   const handleClose = () => {
      setOpen(false);
   };

   const Card = ({ card }) => {


      return (
         <Paper
            elevation={20}
            sx={{
               display: "flex",
               flexDirection: "column",
               justifyContent: "center",
               gap: "15px",
               padding: window.innerWidth < 900 ? "5%" : "1.5%",
               paddingTop: '0',
               maxWidth: window.innerWidth < 900 ? '275px' : "350px",
               minWidth: window.innerWidth < 900 ? '275px' : "300px",
               flex: 1,
               alignItems: "stretch",
               m: window.innerWidth < 800 && 2,
            }}
         >
            <Stack sx={{ height: '100%' }} spacing={2}>
               <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
                  <img
                     alt='nominate-card-img'
                     src={card.img}
                     style={{ maxWidth: "100%", maxHeight: '231px', height: "auto", margin: "auto", borderRadius: '10px' }}
                  />
               </div>
               <h5 style={{ textAlign: "center", flex: 1, fontWeight: '900' }}>{card.name}</h5>
               <h5 style={{ textAlign: "center", height: '70%' }}>{card.content}</h5>
               <NewButton name={card.btnTxt} bgColor={card.bgColor} color={'white'} link={card.btnLink} />

            </Stack>
         </Paper>
      );
   };
   return (
      <div
         style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            justifyContent: "center",
            padding: "2.5%",
            backgroundColor: "white",
            paddingRight: window.innerWidth > 800 && '5%',
            paddingLeft: window.innerWidth > 800 && '5%'
         }}
      >
         <div
            className="register-cards-container"
            style={{
               display: "flex",
               alignItems: "stretch",
               gap: window.innerWidth < 1350 ? "15px" : "5%",
               paddingTop: "2.5%",
               paddingBottom: "2.5%",
               margin: 'auto',
               flexDirection: window.innerWidth < 1150 && "column",
            }}
         >
            {cards.map((card, i) => {
               return <Card key={i} card={card} />;
            })}
         </div>
         <Dialog
            open={open}
            onClose={handleClose}
         >
            <DialogContent>
               <div id="preregForm"></div>
            </DialogContent>
         </Dialog>
      </div>
   );
};
